import api from "../../index.js";

export const GetMTFOpenTradesByLoginIdApi = (loginId) => api.get(`MTFiveAccount/Open-Trade-Details-By-LoginId/${loginId}`);

export const GetMTFCloseTradesByLoginIdApi = (loginId) => api.get(`MTFiveAccount/Close-Trade-Details-By-LoginId/${loginId}`);

export const GetAllLiveAccountsByUserIdApi = (userId) => api.get(`MTFiveAccount/Get-All-Live-Accounts/${userId}`);